/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Alert,
  Spinner,
} from 'react-bootstrap';
import { FaPlus, FaMinus, FaTrash, FaFlask, FaArrowLeft } from 'react-icons/fa';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from '../../services/axios';

function ApiWhatsappEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [url, setUrl] = useState('');
  const [method, setMethod] = useState('POST');
  const [bodyType, setBodyType] = useState('raw');
  const [rawBodyContent, setRawBodyContent] = useState('');
  const [formUrlencodedBody, setFormUrlencodedBody] = useState([
    { key: '', value: '' },
  ]);
  const [headers, setHeaders] = useState([{ key: '', value: '' }]);
  const [ativo, setAtivo] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [testPhone, setTestPhone] = useState('');
  const [testMessage, setTestMessage] = useState('');
  const [showTest, setShowTest] = useState(false);

  // Carregar dados da API ao montar o componente
  useEffect(() => {
    loadApiData();
  }, [id]);

  const loadApiData = async () => {
    try {
      setLoadingData(true);
      const response = await axios.get(`/whatsappproviders/${id}`);
      const apiData = response.data;

      setUrl(apiData.url || '');
      setMethod(apiData.method || 'POST');
      setBodyType(apiData.bodyType || 'raw');
      setAtivo(apiData.ativo !== undefined ? apiData.ativo : true);

      // Processar headers
      if (apiData.headers) {
        try {
          const parsedHeaders =
            typeof apiData.headers === 'string'
              ? JSON.parse(apiData.headers)
              : apiData.headers;
          setHeaders(
            Array.isArray(parsedHeaders) && parsedHeaders.length > 0
              ? parsedHeaders
              : [{ key: '', value: '' }]
          );
        } catch (e) {
          console.error('Erro ao parsear headers:', e);
          setHeaders([{ key: '', value: '' }]);
        }
      } else {
        setHeaders([{ key: '', value: '' }]);
      }

      // Processar body
      if (apiData.body) {
        if (apiData.bodyType === 'raw') {
          setRawBodyContent(
            typeof apiData.body === 'string'
              ? apiData.body
              : JSON.stringify(apiData.body, null, 2)
          );
        } else {
          try {
            const parsedBody =
              typeof apiData.body === 'string'
                ? JSON.parse(apiData.body)
                : apiData.body;
            setFormUrlencodedBody(
              Array.isArray(parsedBody) && parsedBody.length > 0
                ? parsedBody
                : [{ key: '', value: '' }]
            );
          } catch (e) {
            console.error('Erro ao parsear body:', e);
            setFormUrlencodedBody([{ key: '', value: '' }]);
          }
        }
      }
    } catch (err) {
      console.error('Erro ao carregar dados da API:', err);
      toast.error('Erro ao carregar dados da API');
      navigate('/whatsappproviders');
    } finally {
      setLoadingData(false);
    }
  };

  // Função para adicionar nova linha de header
  const addHeaderPair = () => {
    setHeaders([...headers, { key: '', value: '' }]);
  };

  // Função para atualizar header
  const handleHeaderChange = (index, field, value) => {
    const updatedHeaders = headers.map((header, idx) => {
      if (idx === index) {
        return { ...header, [field]: value };
      }
      return header;
    });
    setHeaders(updatedHeaders);
  };

  // Função para remover header
  const removeHeaderPair = (index) => {
    const updatedHeaders = headers.filter((_, idx) => idx !== index);
    setHeaders(updatedHeaders);
  };

  // Função para adicionar nova linha de body form-urlencoded
  const addKeyValuePair = () => {
    setFormUrlencodedBody([...formUrlencodedBody, { key: '', value: '' }]);
  };

  // Função para atualizar body form-urlencoded
  const handleFormUrlencodedChange = (index, field, value) => {
    const updatedBody = formUrlencodedBody.map((item, idx) => {
      if (idx === index) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setFormUrlencodedBody(updatedBody);
  };

  // Função para remover linha de body form-urlencoded
  const removeKeyValuePair = (index) => {
    const updatedBody = formUrlencodedBody.filter((_, idx) => idx !== index);
    setFormUrlencodedBody(updatedBody);
  };

  // Função para submeter o formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Filtrar headers vazios
      const filteredHeaders = headers.filter(
        (header) => header.key.trim() !== ''
      );

      const apiData = {
        url,
        method,
        headers: filteredHeaders.length > 0 ? filteredHeaders : null,
        body: bodyType === 'raw' ? rawBodyContent : formUrlencodedBody,
        bodyType,
        ativo,
      };

      await axios.put(`/whatsappproviders/${id}`, apiData);
      toast.success('API WhatsApp atualizada com sucesso!');
      navigate('/whatsappproviders');
    } catch (err) {
      console.error('Erro ao atualizar API:', err);
      toast.error('Erro ao atualizar API WhatsApp');
    } finally {
      setLoading(false);
    }
  };

  // Função para testar a API
  const handleTest = async () => {
    if (!testPhone || !testMessage) {
      toast.error('Preencha o telefone e a mensagem para teste');
      return;
    }

    setLoading(true);
    try {
      // Testar a API usando a configuração salva
      const response = await axios.post(`/whatsappproviders/${id}/test`, {
        phone: testPhone,
        message: testMessage,
      });

      if (response.data.success) {
        toast.success('Teste realizado com sucesso!');
        console.log('Resposta da API:', response.data.data);
      } else {
        toast.error(
          `Erro no teste: ${response.data.error || 'Erro desconhecido'}`
        );
        console.error('Detalhes do erro:', response.data.details);
      }
    } catch (error) {
      console.error('Erro ao testar API:', error);
      toast.error(
        `Erro ao testar API: ${
          error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : error.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
        <p className="mt-2">Carregando dados da API...</p>
      </Container>
    );
  }

  return (
    <Container fluid>
      <Row className="justify-content-md-center">
        <Col md={10} lg={8}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center">
              <Button
                variant="outline-secondary"
                className="me-3"
                onClick={() => navigate('/whatsappproviders')}
              >
                <FaArrowLeft />
              </Button>
              <h2>Editar API WhatsApp</h2>
            </div>
            <Button
              variant={showTest ? 'secondary' : 'info'}
              onClick={() => setShowTest(!showTest)}
            >
              <FaFlask className="me-2" />
              {showTest ? 'Ocultar Teste' : 'Mostrar Teste'}
            </Button>
          </div>

          {showTest && (
            <Alert variant="info" className="mb-4">
              <h5>Teste da API</h5>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Telefone (com DDD)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="5511999999999 ou 11999999999"
                      value={testPhone}
                      onChange={(e) => setTestPhone(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Mensagem</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Mensagem de teste"
                      value={testMessage}
                      onChange={(e) => setTestMessage(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Button
                variant="success"
                className="mt-2"
                onClick={handleTest}
                disabled={loading}
              >
                Testar API
              </Button>
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={12} lg={8}>
                <Form.Group controlId="apiUrl">
                  <Form.Label>URL da API *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="https://app.servidor.com.br/sendmsg/"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="apiMethod">
                  <Form.Label>Método</Form.Label>
                  <Form.Control
                    as="select"
                    value={method}
                    onChange={(e) => setMethod(e.target.value)}
                  >
                    <option value="POST">POST</option>
                    <option value="GET">GET</option>
                    <option value="PUT">PUT</option>
                    <option value="DELETE">DELETE</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="ativo">
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    as="select"
                    value={ativo}
                    onChange={(e) => setAtivo(e.target.value === 'true')}
                  >
                    <option value>Ativo</option>
                    <option value={false}>Inativo</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            {/* Headers Dinâmicos */}
            <Form.Group className="mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <Form.Label>Headers da Requisição</Form.Label>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={addHeaderPair}
                >
                  <FaPlus className="me-1" /> Adicionar Header
                </Button>
              </div>
              {headers.map((header, index) => (
                <div key={index} className="border rounded p-3 mb-2">
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-2">
                        <Form.Label>Key</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Content-Type, Authorization, token..."
                          value={header.key}
                          onChange={(e) =>
                            handleHeaderChange(index, 'key', e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-2">
                        <Form.Label>Value</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="application/json, Bearer token..."
                          value={header.value}
                          onChange={(e) =>
                            handleHeaderChange(index, 'value', e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12} className="text-end">
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => removeHeaderPair(index)}
                        disabled={headers.length === 1}
                      >
                        <FaTrash /> Remover
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
            </Form.Group>

            <Form.Group controlId="bodyType" className="mt-3">
              <Form.Label>Tipo de Body</Form.Label>
              <Form.Control
                as="select"
                value={bodyType}
                onChange={(e) => setBodyType(e.target.value)}
              >
                <option value="raw">JSON (raw)</option>
                <option value="x-www-form-urlencoded">
                  x-www-form-urlencoded
                </option>
              </Form.Control>
            </Form.Group>

            {bodyType === 'raw' ? (
              <Form.Group controlId="rawBodyContent" className="mt-3">
                <Form.Label>Body da Requisição (JSON)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={8}
                  placeholder={`{
  "type": "0",
  "token": "IAX6F-48479-33726-64985",
  "numero": "{numero}",
  "text": "{mensagem}",
  "departamento": "137301",
  "abrir_atendimento": "1",
  "fechar_atendimento": "1",
  "atendente": "sys"
}

Variáveis disponíveis:
{numero} - Número do telefone
{telefone} - Número do telefone
{mensagem} - Mensagem a ser enviada
{text} - Mensagem a ser enviada`}
                  value={rawBodyContent}
                  onChange={(e) => setRawBodyContent(e.target.value)}
                />
              </Form.Group>
            ) : (
              <Form.Group className="mt-3">
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Label>Body da Requisição (Form)</Form.Label>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={addKeyValuePair}
                  >
                    <FaPlus className="me-1" /> Adicionar Campo
                  </Button>
                </div>
                {formUrlencodedBody.map((item, index) => (
                  <div key={index} className="border rounded p-3 mb-2">
                    <Row>
                      <Col md={12}>
                        <Form.Group className="mb-2">
                          <Form.Label>Key</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="numero, mensagem, token..."
                            value={item.key}
                            onChange={(e) =>
                              handleFormUrlencodedChange(
                                index,
                                'key',
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="mb-2">
                          <Form.Label>Value</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="{numero}, {mensagem}, valor fixo..."
                            value={item.value}
                            onChange={(e) =>
                              handleFormUrlencodedChange(
                                index,
                                'value',
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} className="text-end">
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => removeKeyValuePair(index)}
                          disabled={formUrlencodedBody.length === 1}
                        >
                          <FaTrash /> Remover
                        </Button>
                      </Col>
                    </Row>
                  </div>
                ))}
                <small className="text-muted">
                  Variáveis disponíveis: {'{numero}'}, {'{telefone}'},{' '}
                  {'{mensagem}'}, {'{text}'}
                </small>
              </Form.Group>
            )}

            <div className="d-grid gap-2 mt-4">
              <Button
                variant="primary"
                type="submit"
                size="lg"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Atualizar Configuração'}
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default ApiWhatsappEdit;
